
import { CheckCircle2, PenSquare, Play, Send, Users } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const Process = () => {
  const isMobile = useIsMobile();
  
  const steps = [
    {
      icon: <Send className="text-storystore-blue" size={isMobile ? 24 : 32} />,
      title: "Skicka intresseanmälan",
      description: "Fyll i vårt formulär med information om ditt projekt och dina mål."
    },
    {
      icon: <Users className="text-storystore-blue" size={isMobile ? 24 : 32} />,
      title: "Boka ett möte",
      description: "Vi bokar ett personligt möte för att diskutera din vision och dina behov."
    },
    {
      icon: <PenSquare className="text-storystore-blue" size={isMobile ? 24 : 32} />,
      title: "Vi skickar ett produktionsförslag",
      description: "Baserat på vårt möte skapar vi ett skräddarsytt förslag för din produktion."
    },
    {
      icon: <Play className="text-storystore-blue" size={isMobile ? 24 : 32} />,
      title: "Start av produktion",
      description: "När förslaget är godkänt sätter vi igång med produktionen direkt."
    },
    {
      icon: <CheckCircle2 className="text-storystore-blue" size={isMobile ? 24 : 32} />,
      title: "Feedback och leverans",
      description: "Vi avslutar med feedback, eventuella justeringar och slutleverans."
    }
  ];

  return (
    <section id="process" className="bg-white py-16 sm:py-24">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-16 md:px-8">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-storystore-blue mb-3 sm:mb-4">Hur det fungerar</h2>
          <p className="text-base sm:text-xl text-gray-600 mb-8 sm:mb-12 max-w-3xl mx-auto">
            Från idé till färdig produktion – så här går processen till när du arbetar med oss
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="flex mb-6 sm:mb-8 md:mb-12 relative">
              {/* Line connecting steps */}
              {index < steps.length - 1 && (
                <div className="absolute left-6 sm:left-8 top-12 sm:top-16 w-0.5 sm:w-1 bg-gray-200 h-12 sm:h-16 md:h-16 -z-10"></div>
              )}
              
              {/* Step number and icon */}
              <div className="bg-white mr-3 sm:mr-6 z-10">
                <div className={`flex items-center justify-center ${isMobile ? 'w-12 h-12' : 'w-16 h-16'} rounded-full border-2 border-storystore-red bg-white`}>
                  {step.icon}
                </div>
              </div>
              
              {/* Step content */}
              <div className="flex-1 pt-2 sm:pt-3">
                <h3 className="text-base sm:text-xl font-bold mb-1 sm:mb-2 text-storystore-blue">
                  {index + 1}. {step.title}
                </h3>
                <p className="text-gray-600 text-sm sm:text-base">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-10 sm:mt-16 text-center">
          <a href="#kontakt" className="btn-primary text-sm sm:text-base py-2.5 px-4 sm:py-3 sm:px-6">
            Kom igång med din berättelse
          </a>
        </div>
      </div>
    </section>
  );
};

export default Process;
